/* DO NOT TOUCH :) */

import React from 'react';
import { FaAngleUp } from 'react-icons/fa';

import './scrollbar.css';

const Scrollbar = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    return (
        <div className="top-to-btm" onClick={scrollToTop}>
            <FaAngleUp className="icon-position icon-style" />
        </div>
    );
};

export default Scrollbar;